import React, { Fragment } from "react"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import classes from "./DpWeeksHeader.module.scss"

const monthsName = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"]

const daysName = ["ش", "ی", "د", "س", "چ", "پ", "ج"]

const DpWeeksHeader = props => {
  const {
    minDate,
    maxDate,
    shownDate,
    setShownDate,
    setContent
  } = props
  
  const i18n = useTranslation()[1]

  const handleChangeMonth = action => {
    const newDate = moment(shownDate)

    newDate.add(action, "jMonth")

    setShownDate(newDate)
  }

  const firstDayInShownDateMonth = moment(shownDate)
  firstDayInShownDateMonth.jDate(1)
  firstDayInShownDateMonth.set({ h: 0, m: 0, s: 0, ms: 0 })

  const firstDayInMaxDateMonth = moment(maxDate)
  firstDayInMaxDateMonth.jDate(1)
  firstDayInMaxDateMonth.set({ h: 0, m: 0, s: 0, ms: 0 })

  const firstDayInMinDateMonth = moment(minDate)
  firstDayInMinDateMonth.jDate(1)
  firstDayInMinDateMonth.set({ h: 0, m: 0, s: 0, ms: 0 })

  const showLeftChevron =
    !!minDate
      ? firstDayInShownDateMonth.isAfter(firstDayInMinDateMonth)
      : true

  const showRightChevron =
    !!maxDate
      ? firstDayInShownDateMonth.isBefore(firstDayInMaxDateMonth)
      : true

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["month"]}>
        <button
          className={classes["chevron"]}
          onClick={() => handleChangeMonth(-1)}
        >
          {
            showLeftChevron &&
            <FaChevronRight />
          }
        </button>
        <div
          className={classes["current-month"]}
          onClick={() => setContent("months")}
        >
          {shownDate.jYear()}{" "}
          {monthsName[shownDate.jMonth()]}
        </div>
        <button
          className={classes["chevron"]}
          onClick={() => handleChangeMonth(1)}
        >
          {
            showRightChevron &&
            <Fragment>
              {isLtr ? <FaChevronRight /> : <FaChevronLeft />}
            </Fragment>
          }
        </button>
      </div>
      <div className={classes["days-name"]}>
        {daysName.map(dayName =>
          <div
            key={dayName}
            className={classes["day-name"]}
          >
            {dayName}
          </div>
        )}
      </div>
    </Fragment>
  )
}

export default DpWeeksHeader